import { createRoot } from "react-dom/client";

// Critical paint first
import "./index.css";

// Fonts (local – no network hit)
import "@fontsource-variable/rubik";
import "@fontsource-variable/urbanist";

import App from "./App.tsx";

// Remove prerender helmet duplicates
const helmetTags = document.querySelectorAll('[data-rh="true"]');
helmetTags.forEach(tag => tag.parentNode?.removeChild(tag));

function bootstrap() {
  try {
    const rootElement = document.getElementById("root");
    if (!rootElement) throw new Error("Root element not found");

    // Modulepreload is handled via <link rel="modulepreload"> in HTML
    const root = createRoot(rootElement);
    root.render(<App />);
  } catch (e) {
    console.error("[BOOTSTRAP ERROR]", e);
  }
}

bootstrap();
